import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from './App.js'
import './styles/tokens.css'
import './styles/base.css'
import { SessionProvider } from './session/SessionProvider.js'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: (failureCount, error) => {
        // Non ritentare su 4xx: un 403 non diventa un 200 riprovando.
        const status = (error as { status?: number }).status

        if (status && status >= 400 && status < 500) return false

        return failureCount < 2
      },
    },
  },
})

const root = document.getElementById('root')

if (!root) {
  throw new Error('Elemento #root non trovato.')
}

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <SessionProvider>
        <App />
      </SessionProvider>
    </QueryClientProvider>
  </StrictMode>,
)
